import {
  ReportsTranslations,
  DatasetBase,
  ReportTooltipNormalizedParams,
  ReportTooltipTemplateContext,
} from '@core/reports-types';

import {
  formatNet,
  formatNetChangeValue,
  netChangeSign,
  netColumnName,
  readNetChangeRow,
} from './values';

/**
 * Both net change chart types share one tooltip: the two raw metrics as
 * positive counts (the chart renders one of them below/left of zero, the
 * numbers stay absolute) plus the net in the footer. Net is always shown,
 * independently of the bars, and is read from the results row rather than the
 * chart series - the chart never carries the net column.
 */
export const netChangeTooltipContextFactory = (
  dataset: DatasetBase,
  translations: ReportsTranslations,
  params: ReportTooltipNormalizedParams,
  headerText: string,
): ReportTooltipTemplateContext => {
  const bars = params.filter(param => param.seriesType === 'bar');
  const row = readNetChangeRow(dataset, bars[0]?.dataIndex ?? 0);

  const items = bars.map(param => ({
    id: param.seriesId,
    label: param.seriesName,
    color: <string>param.color,
    value: formatNetChangeValue(
      param.seriesIndex === 0 ? row.positive : row.negative,
      dataset,
      translations.i18n,
    ),
  }));

  return {
    headerText,
    items,
    footerPrimaryText: netColumnName(dataset),
    footerSecondaryText: formatNet(row.net, dataset, translations.i18n),
    footerSign: netChangeSign(row.net),
  };
};
